import { useRef, FC } from "react";
import { Chart, registerables } from "chart.js";
import { Bar, getElementAtEvent } from "react-chartjs-2";
import { IAuroraForcast } from "service/aurora/interface";

Chart.register(...registerables);

type Props = {
  data: IAuroraForcast[];
  setCurrentDate: (local_time: string) => void;
};

const AuroraChart: FC<Props> = ({ setCurrentDate, data }) => {
  const chartRef = useRef();
  const numberOfItems = 45;
  const lastIndex = data ? data.length - 1 : 0;

  data = data ? data?.slice(lastIndex - numberOfItems + 1, lastIndex + 1) : [];
  const labels = data?.map((obj) => obj.predicted_time);
  const values = data?.map((obj) => obj.kp);
  const colors = data?.map((obj) => {
    if (obj.kp > 4) {
      return "#880908";
    } else if (obj.kp === 4) {
      return "#8B8808";
    } else {
      return "#204D0C";
    }
  });

  const onHover = (event: any, elements: any) => {
    if (elements.length === 1) {
      event.native.target.style.cursor = "pointer";
    }
  };

  const onClick = (event: any) => {
    if (chartRef.current) {
      const e = getElementAtEvent(chartRef.current, event);
      if (typeof e?.[0]?.index === "number" && data) {
        setCurrentDate(data[e?.[0]?.index].predicted_time);
      }
    }
  };

  const dataSource = {
    type: "bar",
    labels: labels,
    datasets: [
      {
        label: "Kp",
        data: values,
        backgroundColor: colors,
        barThickness: 10,
      },
    ],
  };

  const options = {
    maintainAspectRatio: false,
    onHover: (event: any, elements: any) => onHover(event, elements),
    plugins: {
      legend: {
        display: false,
      },
    },
    scales: {
      x: {
        ticks: {
          autoSkip: false,
          maxRotation: 60,
          minRotation: 60,
        },
      },
      y: {
        beginAtZero: true,
        display: false,
      },
    },
  };
  
  return <Bar data={dataSource} options={options} onClick={onClick} ref={chartRef} />;
};

export default AuroraChart;
